import { createClient as createGraphqlWsClient } from "graphql-ws";
import { hasClientSession } from "../utils/session";

const getDefaultWsUrl = () => {
  const explicit = process.env.REACT_APP_WS_URL;
  if (explicit) return explicit;

  const apiUrl = process.env.REACT_APP_API_URL;
  if (apiUrl && typeof apiUrl === "string") {
    const trimmed = apiUrl.replace(/\/$/, "");
    const withGraphqlPath = trimmed.endsWith("/graphql")
      ? trimmed
      : `${trimmed}/graphql`;
    if (withGraphqlPath.startsWith("https://")) {
      return withGraphqlPath.replace(/^https:/, "wss:");
    }
    if (withGraphqlPath.startsWith("http://")) {
      return withGraphqlPath.replace(/^http:/, "ws:");
    }
    if (
      withGraphqlPath.startsWith("wss://") ||
      withGraphqlPath.startsWith("ws://")
    ) {
      return withGraphqlPath;
    }
  }

  return "ws://localhost:3000/graphql";
};

export const hasWsAuthToken = () => {
  try {
    if (localStorage.getItem("token")) return true;
    return hasClientSession();
  } catch {
    return false;
  }
};

/**
 * Prefer cookie session (browser sends Cookie on WS upgrade).
 * Legacy: Bearer from localStorage for older sessions.
 */
export const getWsAuthConnectionParams = () => {
  const raw = localStorage.getItem("token");
  if (!raw) return {};
  const authorization = raw.startsWith("Bearer ") ? raw : `Bearer ${raw}`;
  return { authorization };
};

/** Una sola conexión WS compartida (campana, botlogs, reconcile). */
export const graphqlWsClient = createGraphqlWsClient({
  url: getDefaultWsUrl(),
  lazy: true,
  retryAttempts: Infinity,
  retryWait: (retries) => Math.min(1000 + retries * 500, 10000),
  keepAlive: 20000,
  // Cookies for the API host are sent automatically on the upgrade when same-site.
  connectionParams: () => getWsAuthConnectionParams(),
  on: {
    connected: () => {
      if (process.env.NODE_ENV === "development") {
        console.log("[graphql-ws] connected", getDefaultWsUrl());
      }
    },
    error: (error) => {
      console.warn("[graphql-ws] error", error);
    },
    closed: (event) => {
      if (process.env.NODE_ENV === "development") {
        console.log("[graphql-ws] closed", event?.code, event?.reason || "");
      }
    },
  },
});

/** Cierra el socket para que la próxima suscripción abra connection_init con auth actual. */
export const reconnectGraphqlWsClient = () => {
  graphqlWsClient.terminate();
};

if (typeof window !== "undefined") {
  window.addEventListener("storage", (event) => {
    if (event.key === "token" || event.key === "user") {
      reconnectGraphqlWsClient();
    }
  });
}
